import React, { Component } from "react";
import InfoDialogTextViewStyle from "./InfoDialogTextViewStyle";

export default class InfoDialogTextView extends Component {

    private _style = new InfoDialogTextViewStyle();

    render() {
        return (
            <span style={this._style.text}>
                {this.props.children}
            </span>
        );
    }
}